import styled from "styled-components";

export const LoaderStyle = styled.div`
  width: auto;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  .absoluteLoader {
    position: absolute;
    top: ${(props) => `calc(50% - ${props?.size / 2}px)`};
    left: ${(props) => `calc(50% - ${props?.size / 2}px)`};
    width: ${(props) => props?.size};
    height: ${(props) => props?.size};
    display: flex;
    align-items: center;
    justify-content: center;
  }
`;
